<mat-form-field class="label-filter-field" [appearance]="appearance">
  <mat-label *ngIf="fieldLabel">{{ fieldLabel }}</mat-label>
  <mat-select multiple
              placeholder="All"
              panelClass="hmt-label-filter-panel"
              [value]="selectedIds"
              (selectionChange)="onSelectionChange($event)"
              (openedChange)="onOpenedChange($event)">
    <mat-select-trigger>{{ triggerText }}</mat-select-trigger>

    <div class="panel-title">Filter by Label</div>
    <label class="panel-search" *ngIf="labels.length">
      <mat-icon>search</mat-icon>
      <input type="text"
             placeholder="Search labels"
             autocomplete="off"
             [(ngModel)]="search"
             (keydown)="$event.stopPropagation()">
    </label>

    <ng-container *ngIf="labels.length; else noLabels">
      <div class="all-row" *ngIf="!noMatch" (click)="selectAll()">
        <mat-checkbox [checked]="!selectedIds?.length" (click)="$event.preventDefault()"></mat-checkbox>
        <span class="all-pill">All</span>
      </div>
      <ng-container *ngFor="let group of groups">
        <div class="group-title" *ngIf="grouped" [class.hidden]="!groupMatches(group)">{{ group.operationName }}</div>
        <mat-option *ngFor="let label of group.labels; trackBy: trackById"
                    [value]="label.id"
                    [class.hidden]="!matches(label)">
          <hmt-label-chip [label]="label" size="pill"></hmt-label-chip>
        </mat-option>
      </ng-container>
      <div class="panel-empty" *ngIf="noMatch">No labels found</div>
    </ng-container>
    <ng-template #noLabels>
      <div class="panel-empty">No labels available</div>
    </ng-template>

    <div class="panel-footer">{{ selectedIds?.length ? selectedIds.length + ' selected' : 'All labels selected' }}</div>
  </mat-select>
</mat-form-field>
